import {types} from './types';

export function setCommonFontFamily(data) {
  return {
    type: types.SET_FONT_FAMILY,
    payload: data,
  };
}
